/*
const myPath = new CircleTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  radius: 150
});
console.log("myPath", myPath);
layer.add(myPath);
layer.draw();
*/
class CircleTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'CircleTextPath';
    this.attrs.type = "circletextpath";

    this.radius(config?.radius ?? 200);
  }


  static getAttrNames() { return ['radius']; }
  static getDefaultAttrs() { return { amplitude: 200 }; }


  radius(v) {
    if (v === undefined) return this.attrs.radius ?? 0;
    this.attrs.radius = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath(200, 200, this.radius()));
  }


  generateSvgPath(cx, cy, r) {
    // cx: x-coordinate of the circle's center
    // cy: y-coordinate of the circle's center
    // r: radius of the circle

    const startX = cx - r;
    const startY = cy;
    const endX = cx + r;
    const endY = cy;

    // Path for the first semicircle (top half)
    const path1 = `M ${startX} ${startY} A ${r} ${r} 0 1 1 ${endX} ${endY}`;

    // Path for the second semicircle (bottom half)
    const path2 = `A ${r} ${r} 0 1 1 ${startX} ${startY}`;

    // Combine the two paths and close the path with 'Z'
    return `${path1} ${path2} Z`;
  }
}
